"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feedback = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reduxForm = require("redux-form");

var _feedback = require("../../redux/modules/feedback");

var _FeedbackForm = require("../../components/feedback/FeedbackForm");

var _FeedbackForm2 = _interopRequireDefault(_FeedbackForm);

var _feedbackValidator = require("./feedbackValidator");

var _feedbackValidator2 = _interopRequireDefault(_feedbackValidator);

var _FeedbackSuccessPanel = require("../../components/feedback/FeedbackSuccessPanel");

var _FeedbackSuccessPanel2 = _interopRequireDefault(_FeedbackSuccessPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Feedback = exports.Feedback = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Feedback, _Component);

  function Feedback() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Feedback);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Feedback.__proto__ || (0, _getPrototypeOf2.default)(Feedback)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (values) {
      _this.props.sendFeedback(values);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Feedback, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container feedbackPage" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Anna palautetta" }),
        _react2.default.createElement(
          "div",
          null,
          this.defineContent()
        )
      );
    }
  }, {
    key: "defineContent",
    value: function defineContent() {
      if (this.props.feedback.sendFeedbackSuccess) {
        return _react2.default.createElement(_FeedbackSuccessPanel2.default, {
          pushRoute: this.props.pushRoute,
          resetState: this.props.resetFeedback
        });
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_FeedbackForm2.default, {
          fields: this.props.fields,
          handleSubmit: this.props.handleSubmit,
          feedback: this.props.feedback,
          onSubmit: this.submit,
          user: this.props.user
        })
      );
    }
  }]);
  return Feedback;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  sendFeedback: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  feedback: _react.PropTypes.object.isRequired,
  resetFeedback: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object
}, _temp2);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    feedback: state.feedback,
    user: state.auth.user
  };
}, {
  sendFeedback: _feedback.sendFeedback,
  pushRoute: _reactRouterRedux.push,
  resetFeedback: _feedback.resetFeedback
})((0, _reduxForm.reduxForm)({
  form: "feedback",
  fields: ["email", "phone", "name", "message"],
  validate: _feedbackValidator2.default
})(Feedback));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Feedback/Feedback.js
 ** module id = 1213
 ** module chunks = 0
 **/